import { FormHelperText, styled, Typography } from '@mui/material';
import { Column, Row } from 'further-ui/components/Layout';
import React, { PropsWithChildren } from 'react';

const StyledColumn = styled(Column)(() => ({
  maxWidth: '540px',
}));

const StyledTypography = styled(Typography)(() => ({
  minWidth: '120px',
}));

type Props = {
  label: string;
  readOnly: boolean;
  error?: boolean;
  helperText?: string;
};

const DataRow: React.FC<PropsWithChildren<Props>> = ({
  label,
  children,
  error,
  helperText,
  readOnly,
}) => {
  return (
    <StyledColumn>
      <Row fullWidth spacing="md" centered>
        <StyledTypography
          color={readOnly ? 'grey.600' : 'grey.900'}
          variant="h6"
        >
          {label}
        </StyledTypography>
        {children}
      </Row>
      {helperText ? (
        <Row fullWidth justify="flex-end">
          <FormHelperText sx={{ fontWeight: 500 }} error={error}>
            {helperText}
          </FormHelperText>
        </Row>
      ) : null}
    </StyledColumn>
  );
};

export default DataRow;
